import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
  color?: string;
  myStyle?: string;
}

function Peyment({ color , myStyle }: Props): ReactElement {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      width="22"
      height="22"
      className={myStyle ? myStyle : ""}
    >
      <g transform="matrix(1,0,0,1,0,0)">
        <g>
          <path
            d="M45.394,109.199 l289.598-95.558c23.234-7.667,48.68,1.79,61.268,22.77l43.674,72.788"
            fill="none"
            stroke="#155a9e"
            strokeWidth="22"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <path
            d="M466.576,365.361v106.078c0,16.326-13.235,29.561-29.561,29.561H43.508c-16.326,0-29.561-13.235-29.561-29.561V138.76 c0-16.326,13.235-29.561,29.561-29.561h393.506c16.326,0,29.561,13.235,29.561,29.561v106.151"
            fill="none"
            stroke="#424242"
            strokeWidth="22"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <line
            x1="23.065"
            y1="173.726"
            x2="456.149"
            y2="173.726"
            fill="none"
            stroke="#424242"
            strokeWidth="22"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <line
            x1="23.065"
            y1="436.473"
            x2="456.149"
            y2="436.473"
            fill="none"
            stroke="#424242"
            strokeWidth="22"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M477.805,360.142h-88.72c-29.718,0-53.809-24.091-53.809-53.809v-2.466c0-29.718,24.091-53.809,53.809-53.809h88.72 c11.182,0,20.247,9.065,20.247,20.247v69.591C498.052,351.077,488.988,360.142,477.805,360.142z"
            fill="none"
            stroke="#424242"
            strokeWidth="22"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
      </g>
    </svg>
  );
}

export default Peyment;
